import styled from 'styled-components'

const RolesStyle = styled.div`
	--namePositionGlobWrapML: var(--sp18x);
	--itemMTop: var(--sp3x);

	margin-top: var(--bannerDistance);
	margin-bottom: var(--secToTextSecToFooterDistance);

	.rolesWrap {
		display: flex;

		.namePositionGlobWrap {
			margin-left: var(--namePositionGlobWrapML);
		}

		.namePositionInternalWrap {
			&:not(:first-child) {
				margin-top: var(--itemMTop);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeL}) {
		--namePositionGlobWrapML: var(--sp7x);
		--itemMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--namePositionGlobWrapML: var(--sp7x);
		--itemMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--namePositionGlobWrapML: var(--sp8x);
		--itemMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--namePositionGlobWrapML: var(--sp13x);
		--itemMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--namePositionGlobWrapML: var(--sp11x);
		--itemMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSizeS}) {
		--namePositionGlobWrapML: var(--sp7x);
		--itemMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--namePositionGlobWrapML: var(--sp7x);
		--itemMTop: var(--sp2x);

		.rolesWrap {
			margin-top: var(--sp8x);
		}
	}
`

export default RolesStyle
